import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {Logger} from '@common-lib';
import {ActivatedRoute} from '@angular/router';
import {PluginGotenehusMappingDataService} from '../../pages-services/plugin-gotenehus-mapping-data.service';
import {ToasterService} from 'angular2-toaster';
import {TranslateService} from "@ngx-translate/core";
import {ConfirmPopupComponent} from "../../components/confirm-popup/confirm-popup.component";

@Component({
    selector: 'app-plugin-gotenehus-mapping-data',
    templateUrl: './plugin-gotenehus-mapping-data.component.html',
    styleUrls: ['./plugin-gotenehus-mapping-data.component.scss']
})
export class PluginGotenehusMappingDataComponent implements OnInit {

    editModalRef: BsModalRef;
    selectedRow: {
        id: number,
        mappingId: number|string,
        localValue: string,
        remoteValue: string
    };
    searchTerm = '';
    selectedTable = "plugin_gotenehus_product_regions";
    selectedTableArr = [this.selectedTable];

    @ViewChild('editFormTemplate')
    editFormTemplate: TemplateRef<any>;

    tables = [
        {
            name  : 'variants',
            title : 'Variants'
        }, {
            name  : 'plugin_gotenehus_product_regions',
            title : 'PG Product Regions'
        }
    ];

    tableConfiguration = {
        searchEnabled: false,
        headerEnabled: true,
        orderEnabled: true,
        globalSearchEnabled: false,
        paginationEnabled: true,
        exportEnabled: false,
        clickEvent: false,
        selectRow: false,
        selectCol: false,
        selectCell: false,
        rows: 50,
        additionalActions: false,
        serverPagination: false,
        isLoading: false,
        detailsTemplate: false,
        groupRows: false,
        paginationRangeEnabled: true,
        collapseAllRows: false,
        checkboxes: false
    };

    columns = [
        {key: 'id', title: 'ID'},
        {key: 'localValue', title: 'Local Value'},
        {key: 'remoteValue', title: 'Remote Value'},
        {key: 'actions', title: ''}
    ];

    data = [];
    rows = [];
    selected = new Set();
    selectedLocale = 'en-en';

    @ViewChild(ConfirmPopupComponent)
    confirmPopup: ConfirmPopupComponent;

    isSyncing = false;
    constructor(
        private route: ActivatedRoute,
        private pluginGotenehusMappingDataService: PluginGotenehusMappingDataService,
        private modalService: BsModalService,
        private logger: Logger,
        private toasterService: ToasterService,
        private translationService: TranslateService
    ) {
    }

    ngOnInit() {
        this.getList();
    }

    getList() {
        this.pluginGotenehusMappingDataService.getList().subscribe((data) => {
            this.data = data;
            this.search();
        });
    }

    localeChanged() {
        this.pluginGotenehusMappingDataService.getList().subscribe((data) => {
            this.data = data;
            this.search();
        });
    }

    editRow(row) {
        this.selectedRow = row;
        this.editModalRef = this.modalService.show(this.editFormTemplate);
    }

    rowSelected(event) {
        if (event.event === 'onDoubleClick') {
            this.editRow(event.value.row);
        }
    }

    isRowSelected(row) {
        return this.selected.has(this.data.indexOf(row));
    }

    async saveData() {
        let sendObj = Object.assign({}, this.selectedRow);
        if (!sendObj.id) {
            this.pluginGotenehusMappingDataService
                .create(sendObj)
                .subscribe(async (result) => {
                    this.getList();
                    this.toasterService.pop('success', '', await this.translationService.get('webpanel.plugin_gotenehus_mapping_data.created_message').toPromise());
                    this.editModalRef.hide();
                }, (err) => {
                    this.toasterService.pop('error', '', err.message);
                });
        } else {
            this.pluginGotenehusMappingDataService
                .update(sendObj.id, sendObj)
                .subscribe((result) => {
                    this.pluginGotenehusMappingDataService
                        .getList()
                        .subscribe(async (data) => {
                            this.data = data;
                            this.search();
                            this.toasterService.pop('success', '', await this.translationService.get('webpanel.plugin_gotenehus_mapping_data.updated_message').toPromise());
                            this.editModalRef.hide();
                        });
                });
        }
    }

    search() {
        this.rows = this.data.filter((r) => this.searchTerm.length === 0 ||
            r.localValue.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1 ||
            r.remoteValue.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1);

        this.selectedTableArr = [this.selectedTable];

        this.rows = this.rows.filter((r) =>
            r.mapping.tableName == this.selectedTable.toLowerCase()
        );
    }

    addNew() {
        this.selectedRow = {
            id: null,
            localValue: '',
            mappingId : this.selectedTable,
            remoteValue: ''
        };
        this.editModalRef = this.modalService.show(this.editFormTemplate);
    }

    searchKeyPress(event) {
        if (event.which === 13) {
            this.search();
        }
    }

   async removeItem(item) {
        this.selectedRow = item;
        if (this.selectedRow) {
            this.confirmPopup.show();
        }
    }

    confirm(res) {
        if(res) {
            if (this.selectedRow) {
                this.pluginGotenehusMappingDataService.delete(this.selectedRow).subscribe(async (resp) => {
                    this.selectedRow = null;
                    let successMessage = await this.translationService.get('webpanel.plugin_gotenehus_mapping_data.delete.success_message').toPromise();
                    this.toasterService.pop('success', '', successMessage);
                    this.getList();
                });
            }
        }else{
            this.selectedRow = null;
        }
    }

    decline() {
        this.selectedRow = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/plugin-gotenehus-mapping-data/plugin-gotenehus-mapping-data.component.ts